/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageChronologyOverviewPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/text!./templates/SignageChronologyOverviewPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *e
         * @class SignageChronologyOverviewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageChronologyOverviewPage~SignageChronologyOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 9,

            // 更新時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'lowNotYetNum', 'area':'lowNotYetNum', 'area2':'lowNotYetNum'},
                {'item':'lowOnGoingNum', 'area':'lowOnGoingNum', 'area2':'lowOnGoingNum'},
                {'item':'lowCompletedNum', 'area':'lowCompletedNum', 'area2':'lowCompletedNum'},
                {'item':'middleNotYetNum', 'area':'middleNotYetNum', 'area2':'middleNotYetNum'},
                {'item':'middleOnGoingNum', 'area':'middleOnGoingNum', 'area2':'middleOnGoingNum'},
                {'item':'middleCompletedNum', 'area':'middleCompletedNum', 'area2':'middleCompletedNum'},
                {'item':'highNotYetNum', 'area':'highNotYetNum', 'area2':'highNotYetNum'},
                {'item':'highOnGoingNum', 'area':'highOnGoingNum', 'area2':'highOnGoingNum'},
                {'item':'highCompletedNum', 'area':'highCompletedNum', 'area2':'highCompletedNum'}
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setChronologyOverviewInfo();
            },

            /**
             * クロノロジ概況を設定する
             */
            setChronologyOverviewInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 集計値を設定
                    var chronologyOverview = item.items.filter(function(element) {
                        return element.deptName === null;
                    });
                    this.setChronologyOverview(this, chronologyOverview);
                    // 各組織ごとの情報を取得
                    var chronologyList = item.items.filter(function(element) {
                        return element.deptName !== null;
                    });
                    this.setChronologyList(this, chronologyList);
                    // グリッド内の前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var chronologyOverview = {};
                        this.setChronologyOverview(this, chronologyOverview);
                        var chronologyList = [];
                        this.setChronologyList(this, chronologyList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * クロノロジ情報を設定します
             */
            setChronologyOverview: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item];
                });
                this.setChronologyOverviewUpdate(this, item);
            },

            /**
             * 画面上部エリアの更新状態を設定します
             */
            setChronologyOverviewUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem || !item) {
                    return;
                }
                var totalNum = prevItem.items[0];
                if (totalNum) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (totalNum[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            domClass.add(self[target.area2], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                            domClass.remove(self[target.area2], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * クロノロジ情報を設定します
             */
            setChronologyList: function(self, data) {

                // 表示をクリア
                var chronologyListTBody = dojo.byId('chronologyListTBody');
                domConstruct.empty(chronologyListTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                self.currentPage.innerHTML = this._page + 1;
                self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);

                var prevItem = prevItemStore[this._screenId];
                var chronologyList = [];
                if (prevItem) {
                    chronologyList = prevItem.items.filter(function(element) {
                        return element.deptName !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){

                    // 組織の前回値
                    var municPrevItem = null;
                    if (chronologyList && chronologyList.length > 0) {
                        municPrevItem = chronologyList.filter((element) =>
                            element.deptName === item.deptName
                        )[0];
                        // 新規のデータが追加された場合は前回値を0として設定
                        if (municPrevItem === undefined) {
                            municPrevItem = {"notYetNum": 0, "onGoingNum": 0, "completedNum": 0};
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.deptName, class: ' p-1 align-middle text-center table-secondary fw-bold'}), tr);

                    className = municPrevItem && (municPrevItem.notYetNum !== item.notYetNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' p-1 align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.notYetNum + '件', class: className}), tr);

                    className = municPrevItem && (municPrevItem.onGoingNum !== item.onGoingNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' p-1 align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.onGoingNum + '件', class: className}), tr);

                    className = municPrevItem && (municPrevItem.completedNum !== item.completedNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' p-1 align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.completedNum + '件', class: className}), tr);
                                                
                    domConstruct.place(tr, chronologyListTBody);

                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                    // 次の画面に移動させる場合
                    // topic.publish('app/control/SignageControl::next');
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setChronologyList(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }

        });
    });
